import { FC, useCallback } from 'react';
import { Calculator, Landmark } from 'lucide-react';
import { Button } from 'components/ui/Button';
import { useDocumentViewerDialog } from 'components/domain/Document/useDocumentViewerDialog';

const CRD_CALCULATOR_PDF_PATH = '/assets/documents/calculette-crd.pdf';
const BANK_EQUIVALENCE_PDF_PATH = '/assets/documents/equivalence-banques.pdf';

/**
 * Boutons d'accès aux documents de référence statiques (calculette de CRD,
 * équivalences de garanties des banques), affichés sous Historique / Écrire une note.
 * Spécifiques au tunnel emprunteur. Rendus en fragment : le parent les place dans
 * sa grille 2×2 pour que les boutons d'une même colonne aient la même largeur.
 * Ouvre le viewer de document générique dans une modale.
 */
export const ReferenceDocumentButtons: FC = () => {
  const { openDocumentViewer } = useDocumentViewerDialog();

  const handleOpenCrdCalculator = useCallback(() => {
    openDocumentViewer({
      title: 'Info. CRD',
      blobUrl: CRD_CALCULATOR_PDF_PATH
    });
  }, [openDocumentViewer]);

  const handleOpenBankEquivalence = useCallback(() => {
    openDocumentViewer({
      title: 'Équivalences banques',
      blobUrl: BANK_EQUIVALENCE_PDF_PATH
    });
  }, [openDocumentViewer]);

  return (
    <>
      <Button
        round
        color="white"
        onClick={handleOpenCrdCalculator}
        className="w-full !px-2 !py-1.5 shadow-sm hover:ring-2 hover:ring-primary/20 transition-all text-sm"
      >
        <Calculator data-slot="icon" className="text-primary !w-4 !h-4" />
        <span className="text-gray-700 whitespace-nowrap">Info. CRD</span>
      </Button>
      <Button
        round
        color="white"
        onClick={handleOpenBankEquivalence}
        className="w-full !px-2 !py-1.5 shadow-sm hover:ring-2 hover:ring-primary/20 transition-all text-sm"
      >
        <Landmark data-slot="icon" className="text-primary !w-4 !h-4" />
        <span className="text-gray-700 whitespace-nowrap">Équivalences banques</span>
      </Button>
    </>
  );
};
